<template>
  <div class="add-account-page">
    <loader :show="isLoading" />
    <h2 class="page-title">{{ $t("addAccount.title") }}</h2>
    <p class="page-subtitle">{{ $t("addAccount.specifyAccountNumber") }}</p>

    <div class="form-container">
      <input
        v-model="contract_number"
        type="text"
        :placeholder="$t('addAccount.contractPlaceholder')"
      />
      <input
        v-model.number="last_payment"
        type="number"
        :placeholder="$t('addAccount.paymentPlaceholder')"
      />

      <button @click="addAccount" :disabled="isLoading">
        {{ $t("buttons.addAccount") }}
      </button>
    </div>

    <simple-dialog
      v-model="showDialog"
      :title="dialogMessage"
      :success="addAccountMode === 1"
      @change="goToAccountsList"
    />
  </div>
</template>

<script>
import SimpleDialog from "@/components/content/SimpleDialog";
import Loader from "@/components/content/Loader";
import Account from "@/plugins/api/factories/Account";

export default {
  name: "AddAccount",
  components: {
    SimpleDialog,
    Loader,
  },
  data() {
    return {
      contract_number: "",
      last_payment: null,
      showDialog: false,
      addAccountMode: 0,
      dialogMessage: "",
      isLoading: false,
    };
  },
  computed: {
    credentials() {
      return this.$store.state.Auth.userCredentials;
    },
  },
  methods: {
    addAccount() {
      if (
        !this.contract_number ||
        !this.contract_number.trim() ||
        !this.last_payment ||
        this.last_payment <= 0
      ) {
        this.dialogMessage = this.$t("addAccount.fillAllFields");
        this.addAccountMode = 0;
        this.showDialog = true;
        return;
      }

      this.isLoading = true;

      const payload = {
        username: this.credentials.username,
        password: this.credentials.password,
        abonent_code: String(this.contract_number),
        activation_parameter: String(this.last_payment),
      };

      Account.addAccount(
        payload,
        (res) => {
          this.isLoading = false;
          if (res && res.status === "success") {
            this.addAccountMode = 1;
            this.dialogMessage =
              res.message || this.$t("addAccount.successfullyAdded");
            this.$store.dispatch("Auth/loginWithBills", this.credentials);
          } else {
            this.addAccountMode = 0;
            this.dialogMessage =
              res && res.message ? res.message : this.$t("addAccount.notFound");
          }
          this.showDialog = true;
        },
        this.$store.state.Auth.sessionId,
        this.credentials
      );
    },

    goToAccountsList() {
      if (this.addAccountMode === 1) {
        this.$router.push({
          name: "AccountsListPage",
          query: { newAccount: true },
        });
      }
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.add-account-page {
  color: #ecf0f1;
  min-height: 100vh;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.page-title {
  color: #ffffff;
  font-size: 20px;
  font-weight: bold;
}

.page-subtitle {
  color: #bdc3c7;
  font-size: 14px;
  margin-top: 8px;
  margin-bottom: 30px;
  max-width: 300px;
}

.form-container {
  width: 100%;
  max-width: 340px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.password-wrapper {
  position: relative;
  width: 100%;
}

.toggle-password {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #95a5a6;
}

.toggle-password:hover {
  color: #ecf0f1;
}

input {
  background-color: #2c3e50;
  color: #ecf0f1;
  border: 1px solid #34495e;
  padding: 12px;
  font-size: 16px;
  border-radius: 8px;
  width: 100%;
  padding-right: 50px; /* Место для иконки */
}

input[type="number"] {
  padding-right: 12px; /* Возвращаем обычный padding для числового поля */
}

input::placeholder {
  color: #95a5a6;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
  -webkit-appearance: none;
  appearance: textfield;
}

button {
  width: 100%;
  padding: 12px;
  cursor: pointer;
  font-size: 16px;
  background-color: #4277f5;
  color: white;
  border: 1px solid #4277f5;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
  font-weight: bold;
  margin-top: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
}

button:disabled {
  background-color: #566573;
  cursor: not-allowed;
  opacity: 0.6;
}

button:hover:not(:disabled) {
  background-color: #4277f5;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
  transform: translateY(-1px);
}
</style>
